import { render } from "./WaterPoints.vue?vue&type=template&id=d34088e0&scoped=true"
import script from "./WaterPoints.vue?vue&type=script&lang=js"
export * from "./WaterPoints.vue?vue&type=script&lang=js"

import "./WaterPoints.vue?vue&type=style&index=0&id=d34088e0&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34088e0"],['__file',"src/views/WaterPoints.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d34088e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d34088e0', __exports__)) {
    console.log('reload')
    api.reload('d34088e0', __exports__)
  }
  
  module.hot.accept("./WaterPoints.vue?vue&type=template&id=d34088e0&scoped=true", () => {
    console.log('re-render')
    api.rerender('d34088e0', render)
  })

}


export default __exports__